export const gdpr = {
  routes: [
    {
      path: "/gdpr/tasks",
      component: () => import("../gdpr-tasks"),
    },
    {
      path: "/gdpr/tasks/archived",
      component: () => import("../gdpr-archived-tasks"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/tasks",
      component: () => import("../kvkk-tasks"),
    },
    {
      path: "/kvkk/tasks/archived",
      component: () => import("../kvkk-archived-tasks"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/tasks",
      component: () => import("../ddo-tasks"),
    },
    {
      path: "/ddo/tasks/archived",
      component: () => import("../ddo-archived-tasks"),
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/tasks",
      component: () => import("../bgys-tasks"),
    },
    {
      path: "/bgys/tasks/archived",
      component: () => import("../bgys-archived-tasks"),
    },
  ],
};
export const risk = {
  routes: [
    {
      path: "/risk/tasks",
      component: () => import("../risk-tasks"),
    },
    {
      path: "/risk/tasks/archived",
      component: () => import("../risk-archived-tasks"),
    },
  ],
};

export const platform = {
  routes: [
    {
      path: "/tasks",
      component: () => import("../account-tasks"),
    },
    {
      path: "/tasks/:id",
      component: () => import("../account-tasks"),
    },
    {
      path: "/tasks/archived",
      component: () => import("../account-archived-tasks"),
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/tasks",
      component: () => import("../organization-tasks"),
    },
    {
      path: "/organization/tasks/archived",
      component: () => import("../organization-archived-tasks"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/task-category",
      component: () => import("../task-category/management-library-task-category-view"),
    },
  ],
};
export const workspace = {
  routes: [
    {
      path: "/workspace/library/task-category",
      component: () => import("../task-category/workspace-library-task-category-view"),
    },
  ],
};
